import React from "react";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_chicken_croissant_sandwich_1200x900.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganChickenCroissantSandwich() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Chicken Croissant Sandwich",
    content_category: "Vegan Menu",
    content_ids: ["vegan_chicken_croissant_sandwich"],
    content_type: "vegan_banh_mi",
    value: 8.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Chicken Croissant Sandwich | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Vegan croissant filled with vegan grilled chicken, cheese, pâté, tomato, salad, cilantro, jalapeño."
        />
        <meta property="og:title" content="Vegan Chicken Croissant Sandwich | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Vegan croissant filled with vegan grilled chicken, cheese, pâté, tomato, salad, cilantro, jalapeño."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <ProductCard
          cardImg={CardImg}
          titleHead="Vegan Chicken Croissant Sandwich"
          titleSubHead="$8.50 each"
          detailBodyBr="Vegan croissant filled with vegan grilled chicken, cheese, pâté, tomato, salad, cilantro, jalapeño."
          detailBody3="Contains: wheat, soy, almond"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganChickenCroissantSandwich;
